import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";

import { cn } from "@/lib/utils";

export interface WorkspaceSectionHeaderProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  actions?: ReactNode;
  className?: string;
}

export function WorkspaceSectionHeader({
  icon: Icon,
  title,
  description,
  actions,
  className,
}: WorkspaceSectionHeaderProps) {
  return (
    <div
      className={cn(
        "flex items-start justify-between gap-4",
        className
      )}
    >
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <Icon className="h-5 w-5 shrink-0 text-muted-foreground" />
          <h3 className="text-lg font-medium">{title}</h3>
        </div>
        {description ? (
          <p className="mt-1 text-sm text-muted-foreground">{description}</p>
        ) : null}
      </div>
      {actions ? <div className="shrink-0">{actions}</div> : null}
    </div>
  );
}
